<template>
  <v-container>
    <v-row>
      <v-col>
        <div>
          <p class="display-1 primary--text">Summary</p>
        </div>
        <div>
          <p class="headline">
            <span>
              Please review all your responses before submitting.
            </span>
          </p>
        </div>
        <v-container v-if="surveyFlow[1].title" class="display-1 primary--text">
          <strong v-html="surveyFlow[1].title" />
        </v-container>
        <div
          v-for="({ type, field }, index) in surveyFlow[1].fields.filter(
            (f) => f.show === true || f.show === undefined
          )"
          :key="`1_${index}`"
        >
          <Behaviour
            v-if="type === FieldType.Behaviour"
            :behaviour="behaviours[field]"
            :field="field"
            :pageNr="2"
            :isSummaryView="isSummaryView"
          />
          <Verbatim
            v-else-if="type === FieldType.Verbatim"
            :verbatim="verbatims[field]"
            :field="field"
            :pageNr="2"
            :isSummaryView="isSummaryView"
          />
        </div>
        <v-btn
          class="ma-2"
          tile
          color="grey"
          @click="previousPage(surveyFlow.indexOf('Intro') + 2)"
        >
          <v-icon left>mdi-pencil</v-icon> Go back and edit
        </v-btn>
        <div v-if="surveyFlow.indexOf('Improvement') !== -1">
          <Improvement
            :pageNr="surveyFlow.indexOf('Improvement') + 1"
            :isSummaryView="isSummaryView"
          />
          <v-btn
            class="ma-2"
            tile
            color="grey"
            @click="previousPage(surveyFlow.indexOf('Improvement') + 1)"
          >
            <v-icon left>mdi-pencil</v-icon> Go back and edit
          </v-btn>
        </div>
      </v-col>
    </v-row>

    <v-row class="mb-12 mt-12">
      <v-col>
        <p class="font-italic">
          Once you submit this page, your response cannot be edited/changed.
        </p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import Behaviour from '@/components/ATK_180_v1/Behaviour.vue';
import Improvement from '@/components/ATK_180_v1/Improvement.vue';
import Verbatim from '@/components/ATK_180_v1/Verbatim.vue';
import { FieldType } from '@/configuration/FieldType';

export default {
  name: 'SummaryView',

  components: {
    Behaviour,
    Improvement,
    Verbatim,
  },
  data() {
    return {
      isSummaryView: true,
      FieldType,
    };
  },
  computed: {
    ...mapGetters(['surveyFlow']),
    behaviours() {
      return this.$store.state.behaviours;
    },
    verbatims() {
      return this.$store.state.verbatims;
    },
  },
  methods: {
    previousPage(stepNumber) {
      this.$store.commit('previousPage', stepNumber);
    },
  },
};
</script>

<style scoped></style>
